import React from 'react';
import { connect } from 'react-redux';
import locationArrow from '../../../../../assets/images/location-arrow.png';
import mapPin from '../../../../../assets/images/map-pin-icon-filled.svg';
import MapsHelpers from '../../../../../helpers/MapsHelpers/MapsHelpers';

import BaseComponent from '../../../../../baseClasses/BaseComponent'; // Change to point to the right level in the file structure
import './LocationCard.scss';

class LocationCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { distance: -1 };
  }

  componentDidMount() {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((pos) => {
        const coords = pos.coords;
        const currentLocation = {
          lat: coords.latitude,
          lng: coords.longitude,
        };
        const toLocation = {
          lat: this.props.location.latitude,
          lng: this.props.location.longitude,
        };

        MapsHelpers.getDistance(currentLocation, toLocation, (distanceInMiles) => {
          this.setState({ distance: distanceInMiles });
        });
      });
    }
  }

  handleSelection(e) {
    const { handleLocationSelection, location } = this.props;
    if (handleLocationSelection) {
      handleLocationSelection(location);
    }
  }

  render() {
    const { location, company, isSelectedLocation, fullAddress, mapSelected } = this.props;
    if (!location) {
      return null;
    }

    const { distance } = this.state;

    const thousands = Math.floor(distance / 1000);
    const hundreds = distance % 1000;
    let distanceString = distance && distance >= 0 ? (' (' + (thousands ? thousands + ',' : '') + hundreds + ' mi)') : '';    
    let locationTitle = company ? company.name : location.name ? location.name : 'Unlabeled';
    let locationCityDistance = company ? company.city + ', ' + company.state : (location.city + ', ' + location.state + distanceString);
    let locationAddress;
    let notes;
    if(fullAddress){
      locationTitle = location.name ? location.name : 'Unlabeled';
      locationCityDistance = location.address;
      locationAddress = <div className='location-address'>{`${location.city}, ${location.state}`}</div>;
    }

    if(isSelectedLocation && location.notes){
      notes = <div className='location-notes'>
        <div className='notes'>{location.notes}</div>
      </div>; 
    }
    return (
      <div className={'location-card' + (isSelectedLocation ? ' selected' : '')} onClick={this.handleSelection}>
        <img className="location-pin" src={mapPin} alt="Pin" />
        <div className="location-container">
          <div className="location-left-column">
            <div className="location-title">{locationTitle}</div>
            <div className="location-city">{locationCityDistance}</div>
            {locationAddress}
          </div>
          <div className={'location-right-column ' + (mapSelected ? 'selected' : '')}>
            <img className="location-arrow" src={locationArrow} alt="Loc"/>
          </div>
        </div>
        {notes}
      </div>
      
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationCard);




// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/SubHeader/LocationCard/index.js